import styles from "./nav.module.scss";

import { Link, useLocation } from "react-router-dom";

import { BsMoonStars } from "react-icons/bs";

type homeProps = {
  showDashboard?: false;
};

export default function Navbar(props: homeProps) {
  const location = useLocation();

  return (
    <nav className={styles.navigation}>
      {/* Logo */}
      <div className="navigation__logo">
        <Link to="/">
          <p> PLAYBOX </p>
        </Link>
      </div>
      {/* lists */}
      <ul className={styles.navigation__lists}>
        <li
          className={`${styles.navigation__list} ${
            location.pathname === "/about" ? styles.active : ""
          }`}
        >
          <Link to="/about">About</Link>
        </li>

        <li
          className={`${styles.navigation__list} ${
            location.pathname === "/support" ? styles.active : ""
          }`}
        >
          <Link to="/support">Support</Link>
        </li>
        <li
          className={`${styles.navigation__list} ${
            location.pathname === "/start-now" ? styles.active : ""
          }`}
        >
          <Link to="/start-now">Dashboard</Link>
        </li>
        <div className={styles.mode_theme}>
          <BsMoonStars
            className={`${styles.navigation__list} ${styles.theme_icon}`}
          />
        </div>
      </ul>
    </nav>
  );
}
